import moment from 'moment';
import * as fns from 'date-fns';
import { isInvalidDate, stringDateToFormatString } from '../../Common';

/**
 * 必須チェック
 * @param target 対象文字列
 * @returns エラーメッセージ
 * @deprecated エラー文言(E_S001)がハードコーディングされている
 */
export const validRequired = (target: string): string | null => {
  return !target ? '必須項目です' : null;
};

/**
 * 必須チェック
 * @param target 対象文字列
 * @returns 正常:true/異常:false
 */
export const checkRequired = (target: string): boolean => {
  return !!target;
};

/**
 * 半角スペース含む全角チェック
 * @param target 対象文字列(半角英数字、半角記号、半角カタカナ、全角スペース以外)
 * @returns 正常:true/異常:false
 */
export const checkZenkaku = (target: string): boolean => {
  if (!target) return true;
  const regex = /^[^ -~｡-ﾟ\s]+$/;
  return regex.test(target);
};

/**
 * 半角、チェック
 * @param target 対象文字列(半角英数字、半角記号、半角カタカナ)
 * @returns 正常:true/異常:false
 */
export const checkHankaku = (target: string): boolean => {
  if (!target) return true;
  const regex = /^[ -~｡-ﾟ]+$/;
  return !!regex.test(target);
};

/**
 * 半角、記号チェック
 * @param target 対象文字列
 * @returns エラーメッセージ
 */
export const validHankakuSymbol = (target: string): string | null => {
  const regex = /^[^ -~｡-ﾟ\t\f\r\n]+$/;
  return target && !regex.test(target) ? '使用できない文字が含まれています' : null;
};

// /**
//  * Unicode確認
//  * @param target
//  */
// function convertStringToUnicode(target: string) {
//   if (!target) return '';
//   let unicode = '';
//   for (let i = 0; i < target.length; i++) {
//     unicode += target[i].charCodeAt(0).toString(16);
//   }

//   return unicode;
// }

/**
 * 全角カタカナチェック
 * @param target 対象文字列対象文字列(\u30a0-\u30ff: 全角カナ, \u3000: 全角スペース)
 * @returns エラーメッセージ
 * @deprecated エラー文言(E_S004)がハードコーディングされている、checkZenkakuKatakana, checkZenkakuSpaceを組み合わせて使いたい
 */
export const validZenkakuKatakana = (target: string): string | null => {
  const regex = /^[\u30a0-\u30ff\u3000]+$/;
  return target && !regex.test(target) ? '使用できない文字が含まれています' : null;
};
/**
 * 全角カタカナチェック
 * @param target 対象文字列(\u30a0-\u30ff: 全角カナ)
 * @returns 正常:true/異常:false
 */
export const checkZenkakuKatakana = (target: string): boolean => {
  if (!target) return true;
  const regex = /^[\u30a0-\u30ff]+$/;
  return regex.test(target);
};

/**
 * 全角スペースチェック
 * @param target 対象文字列(\u3000: 全角スペース)
 * @returns 正常:true/異常:false
 */
export const checkZenkakuSpace = (target: string): boolean => {
  if (!target) return true;
  const regex = /^[\u3000]+$/;
  return regex.test(target);
};

/**
 * 半角英数(+全角スペース)チェック
 * @param target 対象文字列
 * @returns エラーメッセージ
 */
export const validHankakuAndZenSpace = (target: string): string | null => {
  const regex = /^[0-9a-zA-Z\u3000]+$/;
  return target && !regex.test(target) ? '使用できない文字が含まれています' : null;
};

/**
 * 半角英数チェック
 * @param target 対象文字列
 * @returns エラーメッセージ
 */
export const validHankaku = (target: string): string | null => {
  const regex = /^[0-9a-zA-Z]+$/;
  return target && !regex.test(target) ? '使用できない文字が含まれています' : null;
};

/**
 * 数字チェック
 * @param target 対象文字列
 * @returns エラーメッセージ
 * @deprecated 文言はマスタから取得するように変更するため(各画面で行う)、同クラス内のcheckNumberに移行
 */
export const validNumber = (target: string): string | null => {
  const regex = /^[0-9]+$/;
  return target && !regex.test(target) ? '使用できない文字が含まれています' : null;
};

/**
 * メールアドレス（ローカル部）チェック
 * @param target 対象文字列
 * @returns エラーメッセージ
 */
export const validMailAddressPrefix = (target: string): string | null => {
  const regex = /^[a-zA-Z0-9_+-]+(\.[a-zA-Z0-9_+-]+)*$/;
  return target && !regex.test(target) ? '使用できない文字が含まれています' : null;
};

/**
 * メールアドレス（ドメイン）チェック
 * @param target 対象文字列
 * @returns エラーメッセージ
 */
export const validMailAddressSuffix = (target: string): string | null => {
  const regex = /^([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$/;
  return target && !regex.test(target) ? '使用できない文字が含まれています' : null;
};

/**
 * 電話番号チェック
 * @param target 対象文字列
 * @returns 正常:true/異常:false
 */
export function checkPhoneNumber(target: string): boolean {
  const regex = /^(0{1}\d{9,10})$/;
  return target && !regex.test(target) ? false : true;
}

/**
 * 桁数チェック
 * @param target 対象文字列
 * @returns エラーメッセージ
 * @deprecated 文言はマスタから取得するように変更するため(各画面で行う)、同クラス内のcheckSizeに移行
 */
export const validSize = (target: string, maxSize: number): string | null => {
  return target.length > maxSize ? `${maxSize}文字以内で入力してください` : null;
};

export const validEqualSize = (target: string, size: number): string | null => {
  return target.length !== size && target.trim() !== '' ? `${size}桁で入力してください` : null;
};

/**
 * 日付チェック
 * 年または月のみある場合
 *
 * @param target
 * @param maxSize
 * @returns エラーメッセージ
 */
export const validYearMonth = (yearString: string, monthString: string, itemName: string): string | null => {
  if (!yearString && monthString) {
    return `${itemName}の「年」を選択してください。`;
  } else if (yearString && !monthString) {
    return `${itemName}の「月」を選択してください。`;
  } else {
    return null;
  }
};

/**
 * 対象年が比較日よりの前の年かチェック
 * 対象年を12月31日として計算し比較
 * @param 対象年(yyyy)
 * @param 比較日(yyyyMMdd)
 * @return 対象年が比較日の年より前の場合true
 */
export function isPastYear(targetYear: string, comparisonYMDStr: string) {
  return fns.isBefore(fns.parse(targetYear + '1231', 'yyyyMMdd', new Date()), fns.parse(comparisonYMDStr, 'yyyyMMdd', new Date()));
}
/**
 * 対象日が期間中の月に含まれているかチェック
 * 開始日と比較する場合は月末日
 * 終了日と比較する場合は月初日として計算
 *
 * @param 対象月(yyyyMM)
 * @param 開始日(yyyyMMdd)
 * @param 終了日(yyyyMMdd)
 * @return 対象日が開始日月と終了日月の期間外の場合true, 期間内orデータ不正の場合はfalse
 */
export function isOutOfPeriod(targetYMStr: string, fromDateYMDStr: string, toDateYMDStr: string) {
  const targetYearMonth = fns.parse(targetYMStr + '01', 'yyyyMMdd', new Date());
  return (
    fns.isBefore(fns.endOfMonth(targetYearMonth), fns.parse(fromDateYMDStr, 'yyyyMMdd', new Date())) ||
    fns.isAfter(targetYearMonth, fns.parse(toDateYMDStr, 'yyyyMMdd', new Date()))
  );
}

/**
 * 指定した年月が指定した業務時間か現在システム時間かが更新年月の3年制限に入っているかどうかをチェックする。
 * @param yearString チェックしたい年
 * @param monthString チェックしたい月
 * @param businessDate 現在業務時間帯
 * @returns 制限に沿っていない場合 true 沿っている場合 false
 * @deprecated 246-0対応の中で削除したい
 */
export const invalidRenewalYearMonth = (yearString: string, monthString: string, businessDate?: string) => {
  const businessDateMoment = businessDate ? moment(businessDate, 'YYYYMM') : moment();
  const inputMoment = moment(yearString + monthString, 'YYYYMM');
  return inputMoment.isBefore(businessDateMoment) || inputMoment.isAfter(businessDateMoment.add(3, 'years'));
};

/**
 * 指定した年月が指定した業務時間より未来日であるかどうかを確認する。
 * @param yearString チェックしたい年
 * @param monthString チェックしたい月
 * @param businessDate 現在業務時間帯
 * @returns 過去日の場合 false 当日か未来日の場合 true
 */
export const validFutureYearMonth = (yearString: string, monthString: string, businessDate?: string) => {
  if (!yearString || !monthString) {
    return false;
  }

  const businessDateMoment = businessDate ? moment(businessDate, 'YYYYMM') : moment();
  const inputMoment = moment(yearString + monthString, 'YYYYMM');
  return businessDateMoment.isSameOrBefore(inputMoment);
};

/**
 * 指定した年月日が指定した比較対象日を含む過去日であるかどうかを確認する。
 * @param targetDateStr チェックしたい年月日(yyyyMMddを期待)
 * @param compareDateStr 比較対象日(yyyyMMddを期待)
 * @returns 当日か過去日の場合 true 未来日またはデータ不正の場合 false
 */
export const isBeforeTheDay = (targetDateStr: string, compareDateStr: string) => {
  if (!targetDateStr || !compareDateStr) return false;
  const targetDate = fns.parse(targetDateStr, 'yyyyMMdd', new Date());
  const compareDate = fns.parse(compareDateStr, 'yyyyMMdd', new Date());

  return fns.isBefore(targetDate, compareDate) || fns.isSameDay(targetDate, compareDate);
};

/**
 * 数字チェック
 * @param target 対象文字列
 * @returns 正常:true/異常:false
 */
export const checkNumber = (target: string): boolean => {
  const regex = /^[0-9]+$/;
  return target && !regex.test(target) ? false : true;
};

/**
 * 数値としての範囲チェック
 * @param target 対象文字列
 * @param min 最小値(含む)※整数を期待
 * @param max 最大値(含む)※整数を期待
 * @returns 正常:true/異常:false
 */
export const isNumberInTheRange = (target: string, min: number, max: number): boolean => {
  return checkNumber(target) && Number.isInteger(min) && Number.isInteger(max) && min <= max
    ? Number(target) >= min && Number(target) <= max
    : false;
};

/**
 * 桁数チェック
 * @param target 対象文字列
 * @returns 正常:true/異常:false
 */
export const checkSize = (target: string, maxSize: number): boolean => {
  return target.length > maxSize ? false : true;
};

/**
 * 禁則文字チェック (指定文字列に禁則文字リストが含まれているかどうかをチェックする)
 * ※ 禁則文字リストは必ず重複なしの1文字のstringである前提でチェックします
 * @param target 対象文字列
 * @param prohibitedChars 禁則文字の配列
 * @returns boolean (禁則文字を含む場合 : true, 含まない場合 : false)
 */
export const hasForbiddenCharacter = (target: string, prohibitedChars: string[]): boolean => {
  return RegExp(`[${prohibitedChars.join('')}]`).test(target);
};

/**
 * 桁数と数字チェック
 * 桁数判定と数値であるかをチェックし、違反する場合はエラーメッセージを返却します
 * ※ targetがブランクの場合はチェック自体を行わず、nullを返却します
 * @param target 対象文字列
 * @returns エラーメッセージ
 */
export const checkSizeAndNumber = (target: string, size: number): string | null => {
  // 未入力(ブランク)であった場合はチェックしない
  if (!target) {
    // 未入力(ブランク)である場合エラーなしとしてnullを返却
    return null;
  }
  // 桁数有効判定
  const isValidSize = target.length === size;
  // 数値妥当性判定
  const isValidNumber = checkNumber(target);
  // 有効判定がどちらもtrueである場合エラーなしとしてnullを返却
  if (isValidSize && isValidNumber) {
    return null;
  }
  return `半角数値${size}桁で入力してください`;
};

/**
 * 日付チェック
 * 年または月のみある場合
 *
 * @param yearString
 * @param monthString
 * @returns エラーメッセージ
 */
export const validInputYearAndOptionMonth = (yearString: string, monthString: string): string | null => {
  if (!yearString && monthString) {
    return '年を入力してください';
  } else if (yearString && !monthString) {
    return '月を選択してください';
  } else {
    return null;
  }
};

/**
 * 日付妥当性チェック
 * date-fnsのisValidは"2024-04-31"のような日付も妥当として扱ってしまうため、
 * 日付の妥当性チェックはこの関数を使用して下さい
 * @param targetDateStr チェックしたい年月日
 * @param format 任意(default => yyyy-MM-dd) 必要に応じでformatを指定して下さい
 * @returns 日付として有効である場合true 無効な日付である場合はfalseを返す
 */
export const isValidDate = (targetDateStr: string, format: 'yyyy-MM-dd' | 'yyyyMMdd' = 'yyyy-MM-dd'): boolean => {
  const formattedDateString = stringDateToFormatString(targetDateStr, format, 'yyyy-MM-dd');
  const date = new Date(formattedDateString);

  // Invalid Date 判定
  if (isInvalidDate(date)) {
    return false;
  }
  const formatDate = fns.format(date, format);
  return targetDateStr === formatDate;
};

/**
 * 指定した日付を比較し当月を含む過去かどうかを判定する
 * @param targetDateStr チェックしたい年月日
 * @param businessDate 現在業務時間帯
 * @returns 未来日の場合 false 当月か過去の場合 true
 */
export const isPastOrSameDate = (targetDateStr: string, businessDate?: string): boolean => {
  const inputDateFormat = new Date(targetDateStr);
  const businessDateFormat = businessDate ? fns.parse(businessDate, 'yyyyMMdd', new Date()) : new Date();
  if (isInvalidDate(inputDateFormat) || isInvalidDate(businessDateFormat)) {
    return false;
  }

  return fns.isBefore(inputDateFormat, businessDateFormat) || fns.isEqual(inputDateFormat, businessDateFormat);
};

/**
 * 指定された業務日付が指定されたサービスイン日に入っているか判定する
 * @param businessDate 業務日付
 * @param serviceInDateList サービスイン日
 * @returns boolean
 */
export const isBusinessDateServiceIn = (businessDate: string | undefined, serviceInDateList: string[]) => {
  // 配列が1件のみだった場合、1件目を取得(1件以外の場合は不正とみなし、後続処理で弾くためにundefinedとする)
  // 取得結果はyyyy-MM-dd型を想定 -> 後続処理のためyyyyMMddとなるように置換
  const serviceInDateStr = serviceInDateList && serviceInDateList.length === 1 ? serviceInDateList[0]?.replace(/-/g, '') : undefined;
  // 正確に日付が取れない場合は全てはじく
  return (
    (businessDate &&
      isValidDate(businessDate.slice(0, 8), 'yyyyMMdd') &&
      serviceInDateStr &&
      isValidDate(serviceInDateStr, 'yyyyMMdd') &&
      isBeforeTheDay(serviceInDateStr, businessDate.slice(0, 8))) ||
    false
  );
};
